import { Component, OnInit, Output } from '@angular/core';
import { DatepickerComponent } from '../datepicker-component';
import { DropdownComponent, Item } from '../dropdown-component';
import { mergeAll, mergeMap } from 'rxjs/operators';
import { ViewChild, ViewChildren, QueryList } from '@angular/core';
import { LogsData } from 'src/app/model/LogsData';
import { Food } from 'src/app/model/Food';
import { BackOffServiceService } from 'src/app/services/back-off-service.service';
import  { EdamamManagerService } from 'src/app/services/edamam-manager.service';
import  { FatsecretManagerService } from 'src/app/services/fatsecret-manager.service';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, FormBuilder, Validators, ValidationErrors, Form } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { NgbdModalContent } from '../../alert-component';
import * as Parse from 'parse';
import { EventEmitter } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { MatSelectionList, MatListOption, MatSelectionListChange } from '@angular/material/list';
import { SelectionModel } from '@angular/cdk/collections';
import { type } from 'os';


@Component({
  selector: 'app-food-logs',
  templateUrl: './food-logs.component.html',
  styleUrls: ['./food-logs.component.css'],
  entryComponents: [DatepickerComponent]
})
export class FoodLogsComponent implements OnInit {
  @ViewChildren(DropdownComponent) foodDropdowns : QueryList<DropdownComponent>;
  @ViewChild(DatepickerComponent) datepicker: DatepickerComponent;
  @ViewChild(MatSelectionList) selectionList: MatSelectionList;

  mealIndex = 0;
  portionIndex = 1;
  unitIndex = 10;
  prepIndex = 3;
  @Output() doneSubmiting = new EventEmitter ();
  failedMessage: string;
  cookie: any;
  foodLogSaved: boolean;
  foodlogForm : FormGroup;
  CaloriesReslult : Observable<{}>;
  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset)
  .pipe(
    map(result => result.matches)
  );
  showResults : boolean = false;
  resultsNames : string[] = [];
  results = new Map();
  servingNames : string[] = [];
  servings = new Map();
  haveSelectedFood = false;
  selectedFood = "";
  searchReturnedEmpty = false;
  loggedFoodName = "";

  constructor(
    private router: Router,
    private _bkoffService: BackOffServiceService,
    private formBuilder: FormBuilder,
    private modalService: NgbModal,
    private edamamManagerService: EdamamManagerService,
    private fatsecretManagerService: FatsecretManagerService,
    private breakpointObserver: BreakpointObserver
  ) {
    Parse.initialize(environment.PARSE_APP_ID, environment.PARSE_JS_KEY);
    (Parse as any).serverURL = environment.serverURL;
  }

  ngOnInit() {
    let regexPatterns = {
      quantity: /^(\d+\.?\d*|\.\d+)$/,
    };

    this.foodlogForm  =  this.formBuilder.group({
      foodName: ['', [Validators.required]],
      quantity: ['', [Validators.required, Validators.pattern(regexPatterns.quantity)]]
    });

  }

  get fmBuilder() { return this.foodlogForm.controls; }

  getFormControl(name:any) {
    return this.foodlogForm.get(name);
  }

  closeFoodLog() {
    this.doneSubmiting.emit("saved");
    this.foodLogSaved = true;
  }

  toggleResults() {
    this.showResults = !this.showResults;
  }

  getFormValidationErrors() {
    var missingInput = false;
    Object.keys(this.foodlogForm.controls).forEach(key => {
    const controlErrors: ValidationErrors = this.foodlogForm.get(key).errors;
    if (controlErrors != null) {
          Object.keys(controlErrors).forEach(keyError => {
            console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
            if (keyError === "required"){
              missingInput = true;
            }
          });
        }
      });
      return missingInput;
    }

  searchClick() {
    this.results.clear();
    this.resultsNames = [];
    var foodName = this.foodlogForm.get(['foodName']).value;
    // var res = foodName.split(" ");
    // for (var i = 0; i < res.length; i++) {
    //   if (i == 0) {
    //     foodName = res[i];
    //   } else {
    //     foodName = foodName + "_" + res[i];
    //   }
    // }

    this.fatsecretManagerService.searchFood(foodName).subscribe(res => {
      console.log(res);
      console.log(res.foods.food);
      if (typeof res.foods.food === "undefined") {
        this.showResults = false;
        this.searchReturnedEmpty = true;
        return;

      } else if (res.foods.food.constructor != Array) {
        this.searchReturnedEmpty = false;
        this.showResults = true;
        var name = res.foods.food.food_name;
        var brand = res.foods.food.brand_name;

        if (typeof brand != "undefined") {
          name = name + " - " + brand;
        }
        this.resultsNames.push(name);
        this.results.set(name, res.foods.food.food_id);

      } else {
        this.searchReturnedEmpty = false;
        this.showResults = true;
        for (var i = 0; i < res.foods.food.length; i++) {
          var name = res.foods.food[i].food_name;
          console.log(name);
          const brand = res.foods.food[i].brand_name;
          if (typeof brand !== 'undefined') {
            name = name + ' - ' + brand;
          }
          if (!this.resultsNames.includes(name)) {
            this.resultsNames.push(name);
            this.results.set(name, res.foods.food[i].food_id);  
          }
          if (this.resultsNames.length === 10) {
            break;
          }
        }
      }
    })
  }

  selectFood(food : string) {
    this.showResults = false;
    this.servings.clear();
    this.servingNames = [];
    this.selectedFood = food;
    this.haveSelectedFood = true;
    this.loggedFoodName = food;

    console.log(this.results.get(food));

    this.fatsecretManagerService.getFoodInfo(this.results.get(food)).subscribe(res => {
      console.log(res);
      if (res.food.servings.serving.constructor === Array) {
        for (var i = 0; i < res.food.servings.serving.length; i++) {
          this.servings.set(res.food.servings.serving[i].serving_description, res.food.servings.serving[i].calories);
          this.servingNames.push(res.food.servings.serving[i].serving_description);
        }
      } else {
        this.servings.set(res.food.servings.serving.serving_description, res.food.servings.serving.calories);
        this.servingNames.push(res.food.servings.serving.serving_description);
      }
      
      let dropdowns : DropdownComponent[] = this.foodDropdowns.toArray();
      dropdowns[1].setItems();
      console.log(this.servingNames);  
    });

  }

  submitClick() {
    if (this.foodlogForm.invalid) {
      const modalRef = this.modalService.open(NgbdModalContent);
      if (this.getFormValidationErrors()){
        modalRef.componentInstance.name = 'You have left a question unanswered';
      }
      else{
        modalRef.componentInstance.name = 'Please make sure you have formatted all your inputs correctly';
      }
        return;
    }
    

    let dropdowns : DropdownComponent[] = this.foodDropdowns.toArray();
    var foodLogData = new LogsData();
    foodLogData.portion = this.foodlogForm.get(['quantity']).value;
    foodLogData.meal_type = dropdowns[0].selected;
    foodLogData.measure = dropdowns[1].selected;
    foodLogData.foodDate = (this.datepicker.dateEntry.toString());
    foodLogData.food_name = this.foodlogForm.get(['foodName']).value;
    // var foods = this.edamamManagerService.searchFood(this.foodlogForm.get(['foodName']).value);
    var accessToken : string = '';
    var foodId : string = '';
    var calories = parseInt(this.servings.get(foodLogData.measure));
    calories *= parseFloat(foodLogData.portion);
    foodLogData.calories = calories;
    console.log(calories);

    if (this.foodlogForm.invalid) {
      const modalRef = this.modalService.open(NgbdModalContent);
      if (this.getFormValidationErrors()){
        modalRef.componentInstance.name = 'You have left a question unanswered';
      }
      else{
        modalRef.componentInstance.name = 'Please make sure you have formatted all your inputs correctly';
      }
        return;
    }

    if (dropdowns[1].selected == ' ' || dropdowns[1].selected === undefined || dropdowns[0].selected == ' ' || dropdowns[0].selected === undefined) {
      const modalRef = this.modalService.open(NgbdModalContent);
      modalRef.componentInstance.name = 'You have left a question unanswered';
      return;
    }

      this._bkoffService.createFoodLog(foodLogData).then((success)=>{
        this.doneSubmiting.emit("saved")
        this.foodLogSaved = true;
        this.foodlogForm.reset();
        dropdowns[0].selected = undefined;
        dropdowns[1].selected = undefined;
        const modalRef = this.modalService.open(NgbdModalContent);
        modalRef.componentInstance.name = calories + ' calories have been logged';
        modalRef.componentInstance.title = 'Success';
  
       console.log("successfully savedfood log ")
      }).catch((e)=>{
       this.failedMessage  = "Error saving food logs "
       this.foodLogSaved = false
       
       this.doneSubmiting.emit("failed")
       console.log(e)
      });
  } 

   sendUserFeedback(message:string){
    
      const modalRef = this.modalService.open(NgbdModalContent);
      if (!this.foodLogSaved){
        modalRef.componentInstance.name = message;
      }
     
    }

  
}
